import { useQuery } from '@tanstack/react-query';
import { appConfigFeatureFlagsApi, appConfigFeatureFlagsKeys } from '../api/api';

export function useAppConfigFeatureFlagsQuery() {
  return useQuery({
    queryKey: appConfigFeatureFlagsKeys.all,
    queryFn: () => appConfigFeatureFlagsApi.fetchConfig(),
    staleTime: 30_000,
  });
}
